export default __webpack_public_path__ + "static/media/pic64.980512a6.jpg";